<template>
  <div class="d-flex align-center flex-column ">
      <v-card>
          <s-toolbar label="Autorizacion de Vacaciones" dark color="#8e8f91" close @close="$emit('close')"></s-toolbar>
          <v-card-title style="font-size: small;">
              <v-row>
                  <v-col align="right">
                      <v-tooltip bottom="">
                          <template v-slot:activator="{ on }">
                              <v-btn v-on="on" fab x-small color="info" @click="downloadPdf()">
                                  <v-icon medium>mdi-printer</v-icon>
                              </v-btn>
                          </template>
                          <span>Imprimir Contrato</span>
                      </v-tooltip>
                  </v-col>
              </v-row>
          </v-card-title>
          <hr>
          <v-container style="padding: 25px;">
          <vue-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="false"
              :preview-modal="false"
              :filename="`Contrato`"
              :paginate-elements-by-height="1100"
              :pdf-quality="2"
              pdf-format="a4"
              pdf-orientation="portrait"
              pdf-content-width="695px" 
              :manual-pagination="true"
              :htmlToPdfOptions = "htmlToPdfOptions"
              @progress="onProgress($event)"
              @startPagination="startPagination()"
              @hasPaginated="hasPaginated()"
              @beforeDownload="beforeDownload($event)"
              @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">	
              <section slot="pdf-content"> 
                  <v-container style="padding: 0%; font-size: 11px;" class="pdf-item">
                    <div style="display: flex; justify-content: space-between; align-items: end;">
                        <div>
                          <div style="flex: 0.7; display: flex; justify-content: center; align-items: center;  padding: 10px;">
                                <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto;">
                            </div>
                        </div>
                        <div style="flex: 1.5; display: flex; justify-content: center; align-items: center;  padding: 10px; text-align: center;">
                            <h2 style="margin: 0; font-size: 13px; font-weight: bold; line-height: 14px;">AUTORIZACIÓN DE VACACIONES</h2>
                        </div>
                        <div style="flex: 0.4; display: flex; justify-content: center; align-items: center;  padding: 10px; text-align: center; color: #ff0000">
                            <h2 style="margin: 0; font-size: 13px; font-weight: bold; line-height: 14px;">Nº {{ data.VcdCorrelativeID }}</h2>
                        </div>
                    </div>

                    <table class="tableVacation" style="margin-bottom: 5px;">
                      <thead>
                        <tr>
                            <th colspan="3">FECHA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td style="min-width: 40px;"><div>{{ data?.VcdSecUpdate.split('-')[2] }}</div></td>
                            <td style="min-width: 40px;"><div>{{ data?.VcdSecUpdate.split('-')[1] }}</div></td>
                            <td style="min-width: 40px;"><div>{{ data?.VcdSecUpdate.split('-')[0] }}</div></td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="tableVacation" style="width: 100%;">
                      <thead>
                        <tr>
                            <th><div style="text-wrap: nowrap;">NOMBRE Y APELLIDOS.</div></th>
                            <th><div style="text-wrap: nowrap;">DNI</div></th>
                            <th><div style="text-wrap: nowrap;">AREA</div></th>
                            <th><div style="text-wrap: nowrap;">CARGO</div></th>
                            <th><div style="text-wrap: nowrap;">FECHA DE ING.</div></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td style="min-width: 70px;"><div style="min-height: 25px;">{{ data.NtpFullName}}</div></td>
                            <td style="min-width: 70px;"><div style="min-height: 25px;">{{ data.PrsDocumentNumber }}</div></td>
                            <td style="min-width: 70px;"><div style="min-height: 25px;">{{ data.AreName }}</div></td>
                            <td style="min-width: 70px;"><div style="min-height: 25px;">{{ data.PstName }}</div></td>
                            <td style="min-width: 70px;"><div style="min-height: 25px;">{{ $fun.formatDateView(data.CtrAdmissionDate) }}</div></td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                    <table class="tableVacation" style="width: 100%; margin-bottom: 10px;;">
                      <thead>
                        <tr>
                            <th rowspan="2" style="width: 15%; border-bottom: none !important;">VACACIONES<br>POR GOZAR</th>
                            <th colspan="2" style="width: 30%;">PERIODO CORRESPONDIENTE</th>
                            <th colspan="3" style="width: 40%;">GOCE DEL DESCANSO FISICO</th>
                            <th rowspan="2" style="width: 15%; border-bottom: none !important;">VACACIONES<br>PENDIENTES DE<br>GOCE</th>
                        </tr>
                        <tr>
                            <th style="width: 14%; border-bottom: none !important;">DEL</th>
                            <th style="width: 14%; border-bottom: none !important;">AL</th>
                            <th style="width: 14%; border-bottom: none !important;">DIAS</th>
                            <th style="width: 14%; border-bottom: none !important;">DEL</th>
                            <th style="width: 14%; border-bottom: none !important;">AL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ data?.VctDays }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ data?.VctPeriod.split('-')[0] }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ data?.VctPeriod.split('-')[1] }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ data?.VcdDays }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ $fun.formatDateView(data.VcdDateInit) }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ $fun.formatDateView(data.VcdDateEnd) }}</div></td>
                            <td style="border-top: none !important;"><div style="min-height: 50px;">{{ data?.VctPending }}</div></td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="tableVacation" style="margin-bottom: 5px;">
                        <tr>
                            <th>FECHA DE RETORNO</th>
                            <td><div style="min-width: 250px;">{{ $fun.formatDateView(data?.VcdDateReturn) }}</div></td>
                        </tr>
                    </table>

                    <table class="tableVacation" style="width: 100%;">
                      <thead>
                        <tr>
                            <th style="width: 33.33%;">TRABAJADOR</th>
                            <th style="width: 33.33%;">JEFE DE AREA</th>
                            <th style="width: 33.33%;">Vº Bº RECURSOS HUMANOS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td><div style="min-height: 50px;"></div></td>
                            <td><div style="min-height: 50px;"></div></td>
                            <td><div style="min-height: 50px;"></div></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-container>
              </section>
          </vue-html2pdf>
        </v-container>
      </v-card>
  </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import qrCode from "vue-qr-generator";
import _constapp from "@/plugins/const";
import _sContractService from '@/services/HumanResource/HmnContractService.js';
import { DateTime, Duration } from 'luxon';

export default {

  props: {
    data: {
      type: Object,
      default: null,
    }
  },
  components: {
    VueHtml2pdf,
    qrCode
  },
  data() {
    return {
      dialog: false,
      viewsalary: false,
      htmlToPdfOptions: {
        margin: [0.2, 0.5, 0.2, 0.5],
        filename: `Autorizacion_de_Vacaciones_${this.data?.PrsDocumentNumber}.pdf`,
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        },
        html2canvas: {
          useCORS: true,
          scale: 6,
        },
      },
    }
  },
  methods: {
    capitalize(str, capitalize = true) {
      if (capitalize) {
        return str.trim().split(/\s+/).map(palabra =>
          palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase()
        ).join(" ");
      } else {
        return str.trim().split(/\s+/).map(palabra =>
          palabra.toUpperCase()).join(" ");
      }
    },
    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination() {
      console.log(`PDF has started pagination`)
    },

    hasPaginated() {
      console.log(`PDF has been paginated`)
    },

    beforeDownload({ html2pdf, options, pdfContent }) {
      console.log(`On Before PDF Generation`)
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        // const totalPages = pdf.internal.getNumberOfPages()
        // for (let i = 1; i <= totalPages; i++) {
        //   pdf.setPage(i)
        //   pdf.setFontSize(10)
        //   pdf.setTextColor(150)
        //   pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        // }
      }).save()
        .then(() => {
          this.dialog = false;
        });
    },
  },
  created() {
    console.log('printDataa:', this.data);
    this.data.VcdDateReturn = DateTime.fromISO(this.data.VcdDateEnd).plus(Duration.fromObject({days: 1})).toISODate();
    this.data.VcdSecUpdate = DateTime.fromISO(this.data.SecUpdate).toISODate();
    this.data.VcdCorrelativeID = (this.data.CorrelativeID ?? 0).toString().padStart(6, '0');
  }
}
</script>

<style scoped>
.tableVacation {
    border-collapse: collapse;
}
.tableVacation th, td {
    border: 1px solid black;
    padding: 4px;
    text-align: center;
}
</style>